<section class="download-section product-resources-section pb-5 px-2">
    <p class="product-resource-txt mb-0 pb-3 pb-lg-4">Product Resources</p>
    <div class="download-row-prod" *ngFor="let product of productResourcesData">
        <h3 class="td-title">{{product?.tech_tip_name}}</h3>
        <p [innerHTML]="product?.tech_tip_description" class="td-desc"></p>
        <a class="download-btn" [href]="cdnImagePath + product.resource_file" download="" target="_blank"
            rel="noopener">
            <img [src]="commonImagePath+'download_img.webp'" alt="Download Icon" loading="lazy">Download
        </a>
    </div>
</section>